<template>
  <div class="analysis">
    <!-- 5. 舆论活动分析 -->
    <titleTem :passTitleData="passTitleData"></titleTem>

    <!-- 搜索条件 -->
    <div class="condition_search">
      <el-row>
        <!-- 选择地区:md="12" :lg="6" -->
        <el-col :md="24" :lg="10">
          <div class="option region">
            <div class="item_title">Select Region:</div>
            <el-select
              v-model="regionVal"
              clearable
              placeholder="Please choose"
              :popper-append-to-body="false"
              @change="changeArea"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </div>
        </el-col>

        <!-- 选择时间 :md="12" :lg="8"-->
        <el-col :md="24" :lg="14">
          <div class="option time">
            <div class="time">
              <el-row>
                <el-col :md="24" :lg="5">
                  <div class="item_title date_item">Select Time:</div>
                </el-col>
                <el-col :md="24" :lg="19" v-if="!isMyDate">
                  <el-date-picker
                    @blur="getStartDate"
                    type="date"
                    placeholder="Start date"
                    v-model="startDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsStart"
                    size="large"
                  ></el-date-picker>
                  <span class="to_txt">&nbsp;&nbsp;to&nbsp;&nbsp;</span>
                  <el-date-picker
                    @blur="getEndDate"
                    type="date"
                    placeholder="End date"
                    v-model="endDate"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptionsEnd"
                    size="large"
                  ></el-date-picker>
                </el-col>
                <el-col :md="24" :lg="19" v-else>
                  <DatePicker
                    :startTime="startDate"
                    :endTime="endDate"
                    @startConfirm="startConfirm"
                    @endConfirm="endConfirm"
                    @startCancel="startCancel"
                    @endCancel="endCancel"
                    @startClear="startClear"
                    @endClear="endClear"
                  ></DatePicker>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="echarts_container home_echarts pie_style">
      <EPie :echartsData="pieData" :pieName="pieName" :getSolid="false" :isNodata="isNodata"></EPie>
    </div>
  </div>
</template>

<script>
import titleTem from "../overseas_components/Title";
import EPie from "./components/LocalEpie";
import { listofCountries, industryArea } from "@/common/js/http/version3Api.js";
import DatePicker from "../mobile/DatePickerLocal";

export default {
  name: "Analysis",
  props: {
    country: {
      type: Array,
      default: () => []
    }
  },
  components: {
    titleTem,
    EPie,
    DatePicker
  },
  data() {
    return {
      isMyDate: false,
      isNodata: false,
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.endDate === "" || this.endDate !== "") {
            let endDateVal = 1561910461 * 1000;
            if (endDateVal) {
              return (
                time.getTime() < 1561910461 * 1000 ||
                time.getTime() > new Date(this.endDate).getTime()
              );
            }
          } else {
            let endDateVal = this.endDate;
            if (endDateVal) {
              return time.getTime() > new Date(endDateVal).getTime();
            }
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.startDate === "") {
            let beginDateVal = 1561910461 * 1000;
            if (beginDateVal) {
              return time.getTime() < 1561910461 * 1000;
            }
          } else {
            let beginDateVal = this.startDate;
            if (beginDateVal) {
              return time.getTime() < new Date(beginDateVal).getTime();
            }
          }
        }
      },
      passTitleData: {
        titleName: "Industry Distribution",
        commentTxt:
          "It shows the proportion of news postings in top ten industries in one region within a certain time range (in past 30 days by default)."
      },

      //柱状图数据
      echartsData: [],

      // 饼状图数据
      pieName: "",
      pieData: [
        // { value: 335, name: "Negative" },
        // { value: 315, name: "Helvetica" },
        // { value: 234, name: "Neutral" }
      ],

      // 搜索条件
      regionVal: "",
      industryVal: "",
      industryId: "",
      startDate: "",
      endDate: "",
      dynamicTags: [],
      options: [],
      dynamicTags1: [],
      options1: [],
      clickTruetag: [],
      clickTruetag1: [],
      countryArray: [],
      industryArray: [],
      secondIndustry: [],
      clickState: false,
      timer: null
    };
  },
  created() {
    this.setDate();
    //屏幕宽度
    if(document.documentElement.clientWidth < 768) this.isMyDate = true
    else this.isMyDate = false
  },
  mounted() {
    // this.getlistofCountry();
    this.timer = setTimeout(() => {
      this.getIndustryArea();
    }, 500);
  },
  methods: {
    setDate() {
      this.startDate = this.$moment(new Date())
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      this.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    },
    getStartDate() {
      this.getIndustryArea();
    },
    getEndDate() {
      this.getIndustryArea();
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.clickTruetag.splice(this.clickTruetag.indexOf(tag.value), 1);
      this.options.filter(item => {
        if (item.value === tag.value) {
          item.disabled = false;
        }
      });
      this.regionVal = "";

      this.getIndustryArea();
    },
    getContent(val) {
      this.getIndustryArea();
    },

    //获取国家列表
    getlistofCountry() {
      this.options = this.country;
      this.options.map(item => {
        item.disabled = false;
        return item;
      });
    },

    getIndustryArea() {
      this.pieData = [];
      if( this.startDate == null || this.startDate == 'Invalid date') this.startDate = "";
      if(this.endDate == null || this.endDate == 'Invalid date') this.endDate = "";
      let data = {
        startTime: this.startDate,
        endTime: this.endDate,
        regionalNames: this.clickTruetag
      };
      industryArea(data).then(res => {
        this.pieData = res.result.series;
        this.pieName = res.result.legend.data;
        if (this.pieData.length === 0) {
          this.isNodata = true;
        } else {
          this.isNodata = false;
        }
      });
    },
    //选取国家列表
    changeArea(val) {
      if (this.startDate == null) {
        this.startDate = "";
      }
      if (this.endDate == null) {
        this.endDate = "";
      }
      this.pieName = val;
      this.clickTruetag = [];
      this.clickTruetag.push(val);
      this.getIndustryArea();
    },
    //移动端日期选择
    startConfirm(startTime) {
      this.startDate = this.$moment(new Date(startTime)).format("YYYY-MM-DD");
      this.getIndustryArea();
    },
    endConfirm(endTime) {
      this.endDate = this.$moment(new Date(endTime)).format("YYYY-MM-DD");
      this.getIndustryArea();
    },
    startCancel() {
      this.startDate = "";
      this.getIndustryArea();
    },
    endCancel() {
      this.endDate = "";
      this.getIndustryArea();
    },
    startClear() {
      this.startDate = "";
      this.getIndustryArea();
    },
    endClear() {
      this.endDate = "";
      this.getIndustryArea();
    }
  },
  watch: {
    startDate(newValue) {
      if (newValue === null) {
        this.startDate = "";
        this.getIndustryArea();
      }
    },
    endDate(newValue) {
      if (newValue == null) {
        this.endDate = "";
        this.getIndustryArea();
      }
    },
    changeArea() {
      if (newValue == null) {
        this.getIndustryArea();
      }
    },
    country: {
      handler(newValue) {
        this.getlistofCountry();
      },
      deep: true
    }
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>

<style scoped>
.change_date_time {
  position: relative;
}
.echarts_container {
  display: inline-block;
  position: relative;
  top: 10%;
}

.bar_style {
  width: 100%;
}

.pie_style {
  width: 100%;
}
.time >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 125px !important;
}
.time >>> .el-input--suffix .el-input__inner {
  padding-right: 20px !important;
}
.time .date_item {
  margin-right: 0 !important;
  line-height: 32px !important;
  width: 90% !important;
  text-align: right !important;
  padding-right: 0;
}
.echarts_container > div {
  height: auto !important;
}
.item_title {
  font-size: 14px;
  font-family: RCR;
  color: #4e5671;
  display: inline-block;
  padding-right: 10px;
}
@media screen and (max-width: 1206px) {
  .time .date_item {
    text-align: left !important;
  }
}
.time >>> .cov-date-monthly {
  height: 100px !important;
}
.time >>> .cov-date-monthly > div {
  height: 100px !important;
}
.time >>> .cov-date-caption {
  padding: 30px 0 !important;
}
.time >>> .cov-date-previous::before,
.time >>> .cov-date-previous::after {
  background: #000 !important;
}
.time >>> .cov-date-next::before,
.time >>> .cov-date-next::after {
  background: #000 !important;
}
</style>